import { writable } from 'svelte/store';

export const dismissedLogin = writable(false as boolean);

export const dismissedTerms = writable(false as boolean);
export const termsModalAdded = writable(false as boolean);

export const pageTransitioning = writable(false);
